

module.exports = __webpack_require__.stylable.create(
    "TitleAndTagline2102413572",
    {"classes":{"root":"TitleAndTagline2102413572__root","title":"TitleAndTagline2102413572__title","tagline":"TitleAndTagline2102413572__tagline","badge":"TitleAndTagline2102413572__badge"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "TitleAndTagline2102413572",
    null
);
